import type { BadgeView } from '../../shared/protocol.ts';
import { $, restartAnimation } from '../common/dom.ts';
import { badgeIcon } from '../common/icons.ts';
import type { SoundBoard } from './sound.ts';
import { creatureText } from '../../shared/game-config.ts';

/** Remise d'un badge après la victoire contre un champion. */
export class BadgeCeremony {
  private readonly root = $('#badge-ceremony');
  private readonly sounds: SoundBoard;
  private onDone: (() => void) | null = null;

  constructor(sounds: SoundBoard) {
    this.sounds = sounds;
    $('.evolution-close', this.root).addEventListener('click', () => this.close());
  }

  get isOpen(): boolean {
    return !this.root.hidden;
  }

  play(badge: BadgeView, onDone?: () => void): void {
    this.onDone = onDone ?? null;
    const medal = $('.ceremony-badge', this.root);
    medal.replaceChildren(badgeIcon(badge.icon));
    medal.style.setProperty('--c', badge.color);
    $('.evolution-text', this.root).textContent = `Vous avez obtenu le ${badge.name} !`;
    $('.ceremony-description', this.root).textContent = creatureText(badge.description);
    this.root.hidden = false;
    restartAnimation(this.root, 'celebrating');
    this.sounds.play('victory');
    setTimeout(() => this.sounds.play('levelup'), 900);
  }

  close(): void {
    if (this.root.hidden) return;
    this.root.hidden = true;
    const done = this.onDone;
    this.onDone = null;
    done?.();
  }
}
